import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess';
import { Swiper_PageItem } from 'global/components/swipers/Swiper_PageItem';
import _ from 'lodash';
import React, { Suspense, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { Icon, Label, Visibility } from 'semantic-ui-react';
import { DataContext } from '../cnr/contexts/DataContext';
import { FilterContext } from '../cnr/contexts/FilterContext';
import { FrameworkContext } from '../cnr/contexts/FrameworkContent';
import { PageDataContext } from '../cnr/contexts/PageDataContext';
import { PageDimmerContext } from '../cnr/contexts/PageDimmerContext';
import { ParentContext } from '../cnr/contexts/ParentContext';
import { UiItemContext } from '../cnr/contexts/UiItemContext';
import { g_cns } from '../common/cns';
import { getCheckInCount } from '../common/convert';
import { uniqueKey } from '../common/keys';
import SuspenseDimmer from '../components/alerts/SuspenseDimmer';
import ErrorBoundaryWithNavigate from '../components/errorHandling/ErrorBoundaryWithNavigate';
import AlphabetMenuWithProvider from '../components/menus/AlphabetMenu';
import { gEnums } from '../enums/globalEnums';
import { _animateTypes } from '../motions/AnimateComponent';
import UiFilterPopup from '../sidebars/UiFilterPopup';
import UiItemPopupIcon from '../sidebars/UiItemPopupIcon';
import UiItemSidebar from '../sidebars/UiItemSidebar';
import { getThemeColor } from '../styles/formatting';
import ItemWrapper from '../wrappers/ItemWrapper';
import SemUI from './SemUI';
import UiDataFilters, { fullFilterTypes } from './UiDataFilters';

const AlphabetGrid = React.lazy(() => import('../components/layout/AlphabetGrid'));
const ImageMap = React.lazy(() => import('../components/swipe/ImageMapping'));
const SliderHeader = React.lazy(() => import('./SliderHeader'));
const UiDataModifications = React.lazy(() => import('./modification/UiDataModifications'));
const UiFilter = React.lazy(() => import('./UiFilter'));
const UiFilterSidebar = React.lazy(() => import('../sidebars/UiFilterSidebar'));
const UiItemAction = React.lazy(() => import('../pageItem/modification/UiItemAction'));

const _showMemos = false

// PageAreaContent > PageContent > PageItem > UiItem > SemUi > SemElems > SemCardsWithProvider

/** Builds the UiItem (element) for the PageItem 
 * @returns <SemUI />
 * @returns <UiMaskFilter />  
 * @calledFrom <PageItem/>
*/
const UiItem = (props) => {

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states, fns, handlers } = parentContext ?? {}
  const { currentSettings_state, paps_state, page_state, transition_state } = states
  const { page_handlers, start_handlers } = handlers
  const { navigation_fns } = fns
  const { view, viewKey, settingsDocName, pathViews } = paps_state ?? {}
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { pageSettings } = page_state ?? {}
  const { formatting } = aps_global ?? {}

  const { appDataSource, navigation } = aps_global ?? {}
  const { fetchExistingItems } = appDataSource ?? {}
  const { showItemActionInNavigation } = navigation ?? {}

  const _appUserAccess = useAppUserAccess()

  // // frameworkContext
  const frameworkContext = useContext(FrameworkContext);
  const { framework_state, framework_handlers } = frameworkContext ?? {}
  const { uiItems, pageItems, desktopMode, modifyActionItem } = framework_state ?? {}

  // transitionContext  
  const { transitions } = transition_state ?? {}
  const transition_title = transitions ? transitions[_animateTypes.title] : null
  const { showTransition: showTransition_title } = transition_title ?? {}

  // pageDimmerContext
  const pageDimmerContext = useContext(PageDimmerContext)
  const { pageDimmer_handlers } = pageDimmerContext ?? {}

  // pageDataContext
  const pageDataContext = useContext(PageDataContext);
  const { pageData_state } = pageDataContext ?? {}
  const { currentPageData } = pageData_state ?? {}

  // dataContext
  const dataContext = useContext(DataContext);
  const { data_state } = dataContext ?? {}
  const { viewListData } = data_state ?? {}
  const dataCount = viewListData ? Object.keys(viewListData).length : 0

  // uiItemContext
  const uiItemContext = useContext(UiItemContext)
  const { item_state, item_handlers } = uiItemContext ?? {}
  const { viewItem_key, viewItemStatus, showSingleItemEdit, navigationOptions, allowPopups, viewItem, dataOpts, _groupBys, _filterOpts, _pageOpts, _viewItemOpts, _groupingOpts, modifyActionType, modifyMappingOpen, vld } = item_state ?? {}
  const { _display, itemWrapType, layout, layoutType } = _pageOpts ?? {}
  const { showCount } = _display ?? {}
  const { isCombinedData, uivi } = dataOpts ?? {}
  const { dataModifications, key: key_viewItem } = viewItem ?? {}
  const { credentialing } = dataModifications ?? {}
  const { showCheckedIn } = credentialing ?? {}

  // filterContext
  const filterContext = useContext(FilterContext);
  const { uiFilter_state, uiFilter_handlers } = filterContext ?? {}
  const { groupDataProps } = uiFilter_state ?? {}

  const [currentItem, setCurrentItem] = useState()

  const { caption, displayType, searchOnPage, showFilter, showSearch } = _viewItemOpts ?? {}
  const { alphabetActive, alphaDisplayType, alphaFilterAfter, alphaFilterType, fetchByAlphabet, groupActive, showAlphaHeader, ignoreAlpha } = _groupingOpts ?? {}

  let { groupType } = _groupingOpts ?? {}

  const {
    alphaValue,
    divideIntoGroups,
    filterSidebarOpen,
    filterStatusType,
    groups,
    searchValue,
  } = _filterOpts ?? {}

  const sidebarOn = desktopMode

  // sets up the pageDimmer
  const itemRef = useRef()
  const { current: currentRef } = itemRef ?? {}

  const applySwiper = useMemo(() => {
    let _useSwiper = false
    // groupType
    if (divideIntoGroups) {
      if (groups) {
        if (groups.length > 1) {
          switch (layoutType) {
            case gEnums.layoutTypes.horizontalSliders:
              break;
            default:
              switch (groupType) {
                case gEnums.groupTypes.swipeableGroup:
                  _useSwiper = false
                  break;
                case gEnums.groupTypes.swipeableTab:
                  _useSwiper = true
                  break;
                default:
                // nothing
              }
          }
        }
      }
    }
    switch (displayType) {
      // case gEnums.displayTypes.squares:
      //   return false
      default:
        return _useSwiper
    }
  }, [divideIntoGroups, layoutType])

  useEffect(() => {
    pageDimmer_handlers && pageDimmer_handlers.handleKill_pageDimmer()
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [currentRef]);

  useEffect(() => {
    let _currentItem;

    if (vld && viewListData) {
      start_handlers.handleAmmend_useEffect('PageContext', { vld, viewListData })

      if (fetchExistingItems) {
        if (viewKey) {
          if (uiItems && uiItems[uivi] && uiItems[uivi][viewKey]) {
            _currentItem = uiItems[uivi][viewKey]
          }
        } else {
          if (pageItems && pageItems[uivi]) {
            _currentItem = pageItems[uivi]
          }
        }
      }
      if (_currentItem) {
        setCurrentItem(_currentItem)
      } else {
        const _uiItem = suspenseContent()
        setCurrentItem(_uiItem)
        if (fetchExistingItems) {
          framework_handlers.handleUiItem({ view, viewKey, uivi, _uiItem })
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [vld, viewListData]);

  useEffect(
    () => {
      if (uivi) {
        const _isViewMatch = view === uivi
        framework_handlers.handleAmmend_uivi({
          _appUserAccess,
          viewItemStatus,
          currentPageData,
          viewListData,
          view,
          uivi,
          viewItem,
          viewKey,
          pageSettings,
          settingsDocName,
          navigationOptions,
          _isViewMatch,
          item_state
        }, 'uiItem')
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps  
    }, [view, uivi, viewListData, navigationOptions, item_state]
  )

  useEffect(() => {
    page_handlers.handlePageNav(navigationOptions, uiItemContext)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [navigationOptions, viewItem_key]);

  useEffect(() => {
    if (modifyActionItem?.item === uivi && modifyActionItem?.type) {
      const ct = { modifyActionType: modifyActionItem.type }
      item_handlers.handleSet_modifyAction(ct)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [modifyActionItem]);

  const handleMouseMove = () => {
    const alphaItems = document.querySelectorAll('.card');
    // const mouseY = event.clientY;
    // const index = Math.floor(mouseY / alphaItems[0].offsetHeight);

    // Scroll to the corresponding alpha item
    if (alphaItems[8]) {
      alphaItems[8].scrollIntoView({ behavior: 'smooth' });
    }
  }

  if (!groupType) { groupType = gEnums.groupTypes.swipeableTab }

  let slider = null

  const viewListCount = vld ? Object.keys(vld).length : 0

  if (layoutType === gEnums.layoutTypes.horizontalSliders && viewListCount > 0) {
    if (!slider) {
      slider = {
        horizontalSlider: true,
        showSliderCaption: true,
        sliderCount: layout.viewSliderCount ? layout.viewSliderCount : 10,
        sliderCaption: caption,
        sliderGoToCaption: layout.sliderGoToCaption ? layout.sliderGoToCaption : 'View All'
      }
      if (viewListCount <= 1) { slider.sliderGoToCaption = null }
    }
  }

  const alphaDisplay = () => {
    if (fetchByAlphabet) {
      return <AlphabetMenuWithProvider origin={'uiItem'} />
    } else {
      if (!ignoreAlpha && alphabetActive && alphaDisplayType && !groupActive) {
        switch (alphaDisplayType) {
          case gEnums.alphaDisplayTypes.tab:
            return <AlphabetMenuWithProvider origin={'uiItem'} />
          default:
            return null
        }
      }
    }
    return null
  }

  /**
   * 
   * @returns a tabMenu with the alpha characters
   */
  const alphaTabMenu = useMemo(() => {
    switch (alphaFilterType) {
      case gEnums.alphaFilterTypes.always:
        return alphaDisplay()
      case gEnums.alphaFilterTypes.afterLimit:
        const limit = alphaFilterAfter ? alphaFilterAfter : 100
        if (dataCount > limit) {
          return alphaDisplay()
        }
        break;
      default:
        if (fetchByAlphabet) { return alphaDisplay() }
    }
    return null
  }, [alphaFilterType, alphaFilterAfter, fetchByAlphabet])

  const uiCheckedIn = useMemo(() => {
    if (!showCheckedIn) { return; }
    const total = getCheckInCount(viewListData, view, viewKey)
    return <Label attached='bottom left' size={'mini'} color={'grey'} style={{ margin: '1em' }}>
      <Icon name='check' />
      {total + '/' + dataCount}</Label>
  }, [showCheckedIn])

  const uiCount = useMemo(() => {
    if (!showCount && !showCheckedIn) { return; }
    return <Label attached='bottom left' size={'mini'} color={'grey'} style={{ margin: '1em' }}>
      <Icon name='hashtag' />
      {dataCount}</Label>
  }, [showCount, showCheckedIn])

  const groupByHeader = () => {
    const { indicatorProp, indicatorValue } = _groupBys
    return <div style={{ padding: '.5em', display: 'flex', justifyContent: 'space-between' }}>
      <div> {_.startCase(indicatorProp)}{': '} {indicatorValue}</div>
      <div><Icon name='delete' color='red' onClick={(e) => { uiFilter_handlers.handleFilter_groupBy() }} /></div>
    </div>
  }

  /**
   * 
   * @returns itemCaption, UiFilter, alphaTabMenu, SliderHeader
   */
  // const ui_header = () => <React.Fragment>
  //   <div className={g_cns.item_caption}>{props.caption && itemCaption(props.caption)}</div>
  //   <div className={g_cns.item_filter}> {(showFilter || (showSearch && searchOnPage)) && <UiFilter />}</div>
  //   <div className={g_cns.item_alpha}>{!ignoreAlpha && alphabetActive && !groupActive && alphaTabMenu}</div>
  //   <div className={g_cns.item_group}>{_groupBys && groupByHeader()}</div>
  //   {slider && <SliderHeader viewItem={viewItem} slider={slider} navigation_fns={navigation_fns} />}
  // </React.Fragment>

  const ui_header = () => {
    const showHeader =
      props.caption ||
      (showFilter || (showSearch && searchOnPage)) ||
      (!ignoreAlpha && alphabetActive && !groupActive) ||
      _groupBys ||
      slider

    if (!showHeader) return null

    return (
      <React.Fragment>
        <div className={g_cns.item_caption}>
          {props.caption && itemCaption(props.caption)}
        </div>

        <div className={g_cns.item_filter}>
          {(showFilter || (showSearch && searchOnPage)) && <UiFilter />}
        </div>

        <div className={g_cns.item_alpha}>
          {!ignoreAlpha && alphabetActive && !groupActive && alphaTabMenu}
        </div>

        <div className={g_cns.item_group}>
          {_groupBys && groupByHeader()}
        </div>

        {slider && (
          <SliderHeader
            viewItem={viewItem}
            slider={slider}
            navigation_fns={navigation_fns}
          />
        )}
      </React.Fragment>
    )
  }

  const swiper_pageItem = useMemo(() => {
    const { groupByProp, groups } = groupDataProps ?? {}
    if (!groups && applySwiper) return;


    const itemElements = _.mapValues(
      _.keyBy(groups, 'key'),
      (group) => ({
        key: group.key,
        groupByProp,
        caption: _.startCase(group.namedKey) || _.startCase(group.key),
        content: <SemUI key={uniqueKey('sigi', group.key)} selectedGroupItem={group.key} />
      })
    )

    return <Swiper_PageItem
      swKey={uivi}
      itemElements={itemElements}
      groupDataProps={groupDataProps}
      swipeContentType={gEnums.swipeContentTypes.groupedItems}
    />
  }, [uivi])


  /**
   * 
   * @param {boolean} useSwiper 
   * @returns the content of the ui
   */
  const ui_content = () => {
    let _useSwiper = applySwiper
    if (searchValue) { _useSwiper = false }
    const content = <React.Fragment>
      {filterStatusType !== gEnums.filterStatusTypes.showing && !_useSwiper && <SemUI />}
      {filterStatusType === gEnums.filterStatusTypes.showing && <UiDataFilters fullFilterType={fullFilterTypes.item} />}
      {filterStatusType !== gEnums.filterStatusTypes.showing && _useSwiper && swiper_pageItem}
      {uiCheckedIn}
      {uiCount}
      <div ref={itemRef}></div>
    </React.Fragment>
    return content
  }

  const ui_mapping = () => <ImageMap imageMapType={gEnums.imageMapTypes.itemLocation} />

  /**
   * 
   * @param {boolean} useSwiper 
   * @returns <ItemWrapper with ui_header, UiItemAction and UiItemPopup
   */
  const itemContent = () => {
    return modifyMappingOpen ? ui_mapping() : <ItemWrapper
      header={ui_header()}
      content={modifyActionType ? <UiItemAction /> : ui_content()}
      itemPopup={!modifyActionType && allowPopups && !showItemActionInNavigation && <UiItemPopupIcon />}
      displayType={displayType}
      display={_display}
      useTitleTransition={showTransition_title}
      key_viewItem={key_viewItem}
      dataCount={dataCount}
      alphaDisplayType={alphaDisplayType}
      showAlphaHeader={showAlphaHeader}
    ></ItemWrapper>
  }

  const hv = () => {
    const elems = document.querySelectorAll('.desktop-page-nav > .menu > .item')
    for (let elem of elems) { elem.className = 'item' }
    const elem = document.getElementById('appsbi-' + uivi)
    if (elem) { elem.className += " active" }
  }

  const itemCaption = (content) => <Visibility offset={[10, 10]} onTopPassed={hv} once={false} >
    {content}
  </Visibility>


  // inside uiContent > dataContent

  const mainContent = () => {

    const cid = 'siv-' + uivi
    let containerCn = g_cns.item_container + ' ' + layoutType

    if (allowPopups) { containerCn += ' popup' }
    if (isCombinedData) { containerCn += ' cbn' }
    if (desktopMode && itemWrapType) { containerCn += ' iwt-' + itemWrapType }
    if (dataCount === 1) { containerCn += ' solo' }

    let containerStyle = {}

    if (props.viewItem_app && props.viewItem_app.desktopDisplay && props.viewItem_app.desktopDisplay.backgroundColor) {
      const tc = getThemeColor(aps_global, props.viewItem_app.desktopDisplay.backgroundColor.color)
      containerStyle.backgroundColor = tc
    }

    if (alphabetActive) {

      switch (alphaFilterType) {

        case gEnums.alphaFilterTypes.afterLimit:
        case gEnums.alphaFilterTypes.always:

          switch (alphaDisplayType) {
            case gEnums.alphaDisplayTypes.vertical:
            case gEnums.alphaDisplayTypes.verticalFull:
              return itemContent()

            case gEnums.alphaDisplayTypes.block:
              return <div className={containerCn} id={cid}>
                {slider && <SliderHeader viewItem={viewItem} slider={slider} navigation_fns={navigation_fns} />}
                {itemContent()}
                <UiFilterPopup />
                {!modifyActionType && allowPopups && <UiItemPopupIcon />}
              </div>

            default:
            // nothing
          }
          break;
        default:
        // nothing
      }
    }

    return itemContent()

  }

  // inside uiContent
  const dataContent = () => {
    try {
      return mainContent()
    } catch (error) {
      console.error(error)
      return <div>UiItem Error</div>
    }
  }

  const uiContent = useMemo(() => {

    _showMemos && console.log('useMemo > uiItem', uivi, pathViews)

    if (showSingleItemEdit) {
      return <UiDataModifications modifyActionType={gEnums.dataUpdateTypes.updateDoc} />;
    }

    if (layoutType === gEnums.layoutTypes.horizontalSliders) {
      return (
        <div className={g_cns.app_horz_item}>
          {dataContent()}
        </div>
      );
    }

    if (sidebarOn) {
      return dataContent();
    }

    if (filterSidebarOpen) {
      return (
        <UiFilterSidebar
          content={dataContent()}
          sidebarContent={<AlphabetGrid />}
          item_state={item_state}
          item_handlers={item_handlers}
        />
      );
    }

    if (modifyActionType || !allowPopups) {
      return dataContent();
    }
    return (
      <UiItemSidebar
        content={dataContent()}
        handleMouseMove={handleMouseMove}
      />
    );
  }, [
    allowPopups,
    alphaValue,
    filterSidebarOpen,
    item_state,
    layoutType,
    modifyActionType,
    pathViews,
    showSingleItemEdit,
    sidebarOn,
    viewItem_key,
  ]);

  const suspenseContent = () => <ErrorBoundaryWithNavigate origin={'uiItem'}>
    <Suspense fallback={<SuspenseDimmer origin={'Ui Item'} />}>
      {uiContent}
    </Suspense>
  </ErrorBoundaryWithNavigate>

  if (currentItem) {
    return suspenseContent()
  } else {
    return <div></div>
  }


}

export default UiItem 